import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { NavLink } from "react-router-dom";
import { signOut } from "../../utils/firebase";
import NavDropdown from "react-bootstrap/NavDropdown";
import * as userActions from "../../redux/actions/userActions";

const Header = ({ uid, name, signedIn, actions }) => {
  const handleSignout = () => {
    return signOut();
  };

  return (
    <nav className="navbar navbar-expand-lg d-flex">
      <NavLink className="navbar-brand mr-auto" to={"/cookbook"} exact>
        {name}
      </NavLink>
      {signedIn ? (
        <NavDropdown
          title={
            <svg
              className="bi bi-bullseye"
              width="1em"
              height="1em"
              viewBox="0 0 16 16"
              fill="currentColor"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"
              />
              <path
                fillRule="evenodd"
                d="M8 13A5 5 0 1 0 8 3a5 5 0 0 0 0 10zm0 1A6 6 0 1 0 8 2a6 6 0 0 0 0 12z"
              />
              <path
                fillRule="evenodd"
                d="M8 11a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm0 1a4 4 0 1 0 0-8 4 4 0 0 0 0 8z"
              />
              <path d="M9.5 8a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z" />
            </svg>
          }
          id="nav-dropdown"
        >
          <NavLink className="nav-link" to={`/cookbook/profile/`} exact>
            Profile
          </NavLink>
          {uid && <NavLink
            className="nav-link"
            to={`/cookbook/profile/${uid}/recipe/`}
            exact
          >
            Create Recipe
          </NavLink>}
          <NavDropdown.Divider />
          <p onClick={() => handleSignout()}>Signout</p>
        </NavDropdown>
      ) : (
        <ul className="navbar-nav p-8">
          <li className="nav-item">
            <NavLink className="nav-link" to="/cookbook/login">
              Login
            </NavLink>
          </li>
        </ul>
      )}
    </nav>
  );
};

Header.propTypes = {
  name: PropTypes.string.isRequired,
  uid: PropTypes.string,
  signedIn: PropTypes.bool,
  actions: PropTypes.object,
};

function mapStateToProps(state) {
  return {
    name: "Rae and Regan's Cookbook",
    uid: state.user.firebase_uid,
  };
}

function mapDispatchToProps() {
  return {
    actions: {
      clearUser: userActions.clearUser,
    },
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Header);
